import React from 'react';
import { Nav } from 'react-bootstrap';
import {Link} from "react-router-dom";
//import styles from './Screenwriting.css';

function Screenwriting() {
  return (
<div className="mainContent">
<h1>Screenwriting Services</h1>
<p>Claire is a produced screenwriter and producer, the author of over 20 scripts, some award-winning, and she has consulted on scripts that have been produced and that have been nominated for awards. She is probably one of the few script analysts who has actually been writing scripts for over 20 years.</p>
<p>Claire performs the following:</p>
<ol>
  <li>Screenwriting</li>
  <li>Script Consulting (See the page entitled <Nav.Link as={Link} to="Consulting" className="inlineLink" href="#Consulting">Script Consulting</Nav.Link>)</li>
  <li>Script Coaching</li>
  <li>Books Into Scripts</li>
  <li>Film Cut Analysis</li>
  <li>Producing</li>
</ol>

<h2>Screenwriting</h2>
  <p>For screenwriting services, the charge is usually the WGA rate for producers. For budgets under 5 million, the charge is usually 3-5% of the total production budget. 
  If you are not a producer but you have an idea, treatment, or script you would like us to work on, please contact us with what you have and we'll quote you a price. 
  Please email <a href="mailto:claire@clairehutchinson.net">claire@clairehutchinson.net</a>.</p>  
<h2>Script Consulting</h2>  
<p>Please see the page entitled <Nav.Link as={Link} to="Consulting" className="inlineLink" href="#Consulting">Script Consulting</Nav.Link>.</p>
<h2>Script Coaching</h2>
<p>Numerous clients have been satisfied with our script coaching services: We will take you from initial concept, to outline, and up to five drafts of your script for $5500. This includes weekly phone calls.</p>
<h2>Books Into Scripts</h2>
<p>We have been turning books into screenplays for awhile, starting out with author Carolyn Snelling's book, "The Mystery of the Christmas Stars." 
  Other screenplay adaptations include "Crosscurrents" and "Heroes from Heaven." "Lone Oak," from the novel by Philip Hardy, is now in pre-production. The trailer for "Lone Oak" was an Official Nominee of the 2023 ICFF.</p>
<h2>Film Cut Analysis</h2>
<p>Having judged multiple film festivals and script contests over the last 20 years, we have branched out to provide film cut analysis, where we analyze films which are edited but not yet ready to be shown. 
  We offer suggestions for improvement, both technical and story-related.</p>
<h2>Producing</h2>
<p>We have produced the award-winning film, "Living the Dream" and would be interested in producing your film. However, the film should be fully funded. We are producers for hire and do not provide funding for films.</p>
<p>Please email <a href="mailto:claire@clairehutchinson.net">claire@clairehutchinson.net</a> for details on submitting your script and payment.</p>
</div>
)
}
export default Screenwriting;
